// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.solutions.openedge.OpenEdgePracticeLocationResponse */
/* istanbul ignore next */
@GandalfModel
export class OpenEdgePracticeLocationResponse extends GandalfModelBase {

	@GandalfArray(String)
	cardReaderNames!: string[] | null;

	@GandalfProperty({ designType: Boolean })
	openEdgeIsActive!: boolean | null;

	@GandalfProperty({ designType: Number })
	openEdgeSettingsId!: number | null;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfProperty({ designType: String })
	practiceLocationName!: string | null;

}
